// src/App.js
// src/App.js
import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';
import HomePage from './pages/HomePage';
import LandingPage from './pages/LandingPage'; // Import the new LandingPage
import MenuPage from './pages/MenuPage';
import EditMenuPage from './pages/EditMenuPage';
import AiMenuPage from './pages/AiMenuPage'; // Import the new AI Menu page
import CreateRestaurantPage from './pages/CreateRestaurantPage';
import RestaurantEditPage from './pages/RestaurantEditPage'; // Import the Restaurant Edit page
import OrdersPage from './pages/OrdersPage'; // Import the Orders page
import OrderSettingsPage from './pages/OrderSettingsPage'; // Import the Order Settings page
import NotFoundPage from './pages/NotFoundPage';
import DebugMonitor from './components/DebugMonitor';
import './App.css';
import TableBookingPage from './pages/TableBookingPage.js'; // Import the Table Booking page
import OnlineOrderPage from './pages/OnlineOrderPage.js'; // Import the Online Order page
import AdminLoginPage from './pages/AdminLoginPage'; // Import Admin Login Page
import AdminDashboardPage from './pages/AdminDashboardPage'; // Import Admin Dashboard Page
import RestaurantDashboardPage from './pages/RestaurantDashboardPage'; // Import Restaurant Dashboard Page
import ManageMenusPage from './pages/ManageMenusPage'; // Import Manage Menus Page
import QRCodeGeneratorPage from './pages/QRCodeGeneratorPage'; // Import QR Code Generator Page
import { AdminProtectedRoute } from './components/ProtectedRoute'; // Import Admin Protected Route

// Enable debug mode in development or with URL parameter
const isDebugMode = process.env.NODE_ENV === 'development' || 
                    window.location.search.includes('debug=true');

// Define routes using the object-based format
const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/home", // New route for the original HomePage
    element: <HomePage />,
  },
  {
    path: "/create",
    element: <CreateRestaurantPage />,
  },
  {
    path: "/:slug",
    element: <MenuPage />,
  },
  {
    path: "/edit/:restaurantId",
    element: <EditMenuPage />,
  },
  {
    path: "/ai-menu/:restaurantId",
    element: <AiMenuPage />,
  },
  {
    path: "/restaurant-edit/:restaurantId", // Add route for editing restaurant details
    element: <RestaurantEditPage />,
  },
  {
    path: "/orders/:restaurantId", // Add route for the orders page
    element: <OrdersPage />,
  },
  {
    path: "/order-settings/:restaurantId", // Add route for the order settings page
    element: <OrderSettingsPage />,
  },
  {
    path: "/dashboard/:restaurantId", // Add route for the restaurant dashboard page
    element: <RestaurantDashboardPage />,
  },
  {
    path: "/manage-menus/:restaurantId", // Add route for the manage menus page
    element: <ManageMenusPage />,
  },
  {
    path: "/qr-generator/:restaurantId", // Add route for the QR code generator page
    element: <QRCodeGeneratorPage />,
  },
  {
    path: "/:slug/table-booking",
    element: <TableBookingPage />,
  },
  {
    path: "/:slug/online-order",
    element: <OnlineOrderPage />,
  },
  {
    path: "/404",
    element: <NotFoundPage />,
  },
  {
    path: "*",
    element: <Navigate to="/404" replace />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: <AdminProtectedRoute />,
    children: [
      {
        path: "dashboard",
        element: <AdminDashboardPage />,
      },
      {
        path: "", // Default /admin to /admin/dashboard
        element: <Navigate to="/admin/dashboard" replace />,
      }
    ]
  },
], {
  // Enable future flags
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
});

// Note: The RedirectHandler logic might need adjustment or integration 
// into the route elements if session-based redirects are still required.

function App() {
  console.log('App rendering.'); // Simplified log

  return (
    <>
      <RouterProvider router={router} />
      {/* Debug monitor - visible in development or with ?debug=true in URL */}
      <DebugMonitor isActive={isDebugMode} />
    </>
  );
}

export default App;